import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';

@Component({
  selector: 'app-distance-update',
  templateUrl: './distance-update.component.html',
  styleUrls: ['./distance-update.component.scss'],
})
export class DistanceUpdateComponent implements OnInit {
  userForm: FormGroup;
  currentUser: any;

  constructor(
    public dialogRef: MatDialogRef<DistanceUpdateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private service: PagesService,
    private loader: NgxUiLoaderService,
    private storageService: LocalStorageProvider,
    private toaster: ToastrService
  ) {
    this.userForm = this.fb.group({
      distanceAPI: [''],
    });
  }
  ngOnInit(): void {
    console.log(this.data)
    this.userForm.patchValue({
      distanceAPI: this.data?.currentUser,
    });
  }

  onSubmit() {
    const data = {
      aimrService: this.userForm.value.distanceAPI,
    };
    if (this.userForm.valid) {
      this.loader.start();
      this.service
        .post(data, `${API_ROUTES.ACCOUNT.editProfile}`)
        .pipe()
        .subscribe(
          (response: any) => {
            this.loader.stop();
            if (response.status) {
              console.log(response, 1);
              this.currentUser = this.storageService.getItem('CurrentUser');
              this.currentUser.aimrService = response?.data?.aimrService;
              this.currentUser.aimrServiceLastUpdatedAt = response?.data?.aimrServiceLastUpdatedAt;
              this.storageService.setItem('CurrentUser', this.currentUser);
              this.dialogRef.close(response?.data);
              this.loader.stop();
              this.toaster.success(response.msg);
            } else {
              this.loader.stop();
              this.dialogRef.close();
              this.toaster.info(response);
            }
          },
          (err) => {
            this.loader.stop();
            this.dialogRef.close();
            this.toaster.info(err.msg);
          }
        );
    }
  }
}
